import Image from "next/image";

import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ClientOnly from "components/ClientOnly";

interface SectionTicketProps {
  html: string;
  imageUrl?: string;
}

const SectionTicket: FC<SectionTicketProps> = ({ html, imageUrl }) => {
  return (
    <Box display="grid" gap={2} mb={2}>
      <ClientOnly>
        <Typography
          dangerouslySetInnerHTML={{
            __html: html,
          }}
        />
      </ClientOnly>
      {imageUrl && (
        <Image
          src={imageUrl}
          alt="ticket"
          width={300}
          height={800}
          style={{
            maxWidth: "100%",
            objectFit: "contain",
            height: "auto",
            margin: "0 auto",
          }}
        />
      )}
    </Box>
  );
};

export default SectionTicket;
